import { Stack, Typography } from "@mui/material";
import React from "react";
import { Logo } from "./logo";

export function myTWHeading() {
  return (
    <Typography variant={"h1"} color={"primary.dark"}>
      <Stack direction={"row"} alignItems="flex-end">
        <Stack direction={"row"} alignItems="center">
          <Logo />
          <Typography variant={"h1"} color={"primary.main"} fontFamily="Inter">
            &nbsp;myTW
          </Typography>
        </Stack>
      </Stack>
    </Typography>
  );
}
